export function splitUppercase(str: string, sep = " "): string {
  if (str) {
    const str2 = str.replace(/([A-Z])/g, `${sep}$1`)
    return str2.substring(sep.length, str2.length)
  } else {
    return str
  }
}

/**
 * Returns the string or empty string when value is undefined or null
 * @param {String} str
 * @returns {String}
 */
export function trim(str: string): string {
  if (str === undefined || str === null) {
    return ""
  } else {
    return str
  }
}

export function joinStrings(arr: string[]): string {
  if (arr.length <= 2) {
    return arr.join(" and ")
  } else {
    let str = arr.slice(0, arr.length - 1).join(", ")
    return `${str} and ${arr[arr.length - 1]}`
  }
}

export function pluralizeBy(str: string, num: number): string {
  return num > 1 ? (str += "s") : str
}

export function colorBoolean(
  value: boolean,
  trueColor = "text-green-500",
  falseColor = "text-red-500"
): string {
  return value ? trueColor : falseColor
}

export function blankOrValue(
  value: string,
  blank: string,
  blankClass = "text-gray-500 text-sm italic"
): string {
  if (value && value.length > 0 && value !== "<p></p>") {
    return value
  } else {
    return `<span class="${blankClass}">${blank}</span>`
  }
}

export function titleize(str) {
  var words = str.replace(/_|-/g, ' ').split(' ')
  var array = []
  for (var i = 0; i < words.length; ++i) {
      array.push(words[i].charAt(0).toUpperCase() + words[i].toLowerCase().slice(1))
  }
  return array.join(' ');
}